import { Field } from 'formik';
import { Input, FormControl, Grid, GridItem, Box, Image, useStyleConfig, Heading, Button } from '@chakra-ui/react';
import ElementInstructions from './components/ElementInstructions';
import ElementHeading from './components/ElementHeading';
import ElementErrorMessage from './components/ElementErrorMessage';
import { transformRSInput } from '../formControllers/Transformation/Utils.js';
import InputWrapper from './components/InputWrapper';
import ReactPlayer from 'react-player';
import { progressiveFormStepper } from '../components/ProgressiveFormStepper/utils';
import { exitToMenu } from '../formSections/utils';

const Display = ({ fieldName, qObj, jobSeekerData, handlers, props, index }) => {
  const variant = 'wrapper';
  const buttonStyles = useStyleConfig('Button', { variant });
  const elementStyles = useStyleConfig('Element', { variant });
  let justify = 'space-between';
  let question = undefined;
  let alignment = 'display center';
  if (qObj.question !== undefined && qObj.question !== '') {
    question = qObj.question;
    alignment = 'display left';
  }
  const playIcon = props.stateProps.domain + '/app/images/playArrow.png';

  if (qObj.instructions === undefined || qObj.instructions === '') {
    justify = 'center';
  }
  return (
    <Box sx={{ ...elementStyles }}>
      <Field name={fieldName}>
        {({ field, form }) => (
          <Box className={alignment}>
            <Box className="heroImageBox">
              <ReactPlayer
                border='1px solid #333'
                url={qObj.video}
                controls={true}
                className="heroImageImg"
              />
            </Box>
            {question !== undefined && (
              <Box area="form" className="formWrapper">
                <Heading className="qHeading">{question}</Heading>
                <Box>
                  <Box props={props} className="instructions">
                    {qObj.instructions}
                  </Box>
                </Box>
              </Box>
            )}

          </Box>
        )}
      </Field>
    </Box>
  );
};

export default Display;

